import React from 'react';
import { DropDown } from 'src/components-dummy';
import { MerchandisingRuleTypes } from 'src/services';
import { needsConditionValueInput, ConditionFieldCategory } from './helpers';

export interface ConditionValueInputProps {
  subType: MerchandisingRuleTypes.MerchandisingRuleSubType | '';
  category: ConditionFieldCategory;
  value: string;
  onChange: (value: string) => void;
  className: string;
}

// Renders the condition's value control - a True/False dropdown for boolean fields, otherwise a
// plain text/number input - or nothing when the chosen subtype doesn't take a value (EqualsSource).
export const ConditionValueInput = ({
  subType,
  category,
  value,
  onChange,
  className,
}: ConditionValueInputProps): JSX.Element | null => {
  if (!needsConditionValueInput(subType as MerchandisingRuleTypes.MerchandisingRuleSubType)) {
    return null;
  }

  if (category === 'boolean') {
    return (
      <DropDown
        placeholder='Value'
        options={[
          { value: 'true', text: 'True' },
          { value: 'false', text: 'False' },
        ]}
        value={value || undefined}
        onChange={val => onChange(String(val))}
        className={className}
      />
    );
  }

  return (
    <input
      type={category === 'numeric' ? 'number' : 'text'}
      placeholder='Value'
      className={className}
      value={value}
      onChange={event => onChange(event.target.value)}
    />
  );
};
